type ErrorLikeRecord = {
  status?: unknown
  code?: unknown
  message?: unknown
  resultCd?: unknown
  result_cd?: unknown
  resultCdName?: unknown
  result_cd_name?: unknown
  resultMsg?: unknown
  cause?: unknown
  data?: unknown
}

const isRecord = (value: unknown): value is ErrorLikeRecord => {
  return typeof value === 'object' && value !== null
}

const getResultCode = (value: ErrorLikeRecord) => {
  return Number(value.status ?? value.resultCd ?? value.result_cd)
}

const hasNotFoundMarker = (value: ErrorLikeRecord) => {
  const resultCode = getResultCode(value)

  if (resultCode === 404) {
    return true
  }

  const candidates = [value.code, value.message, value.resultCdName, value.result_cd_name, value.resultMsg]

  return candidates.some((candidate) => typeof candidate === 'string' && candidate.includes('NOT_FOUND'))
}

export const isPrestudyRoomCreationUnavailableError = (error: unknown, depth = 0): boolean => {
  if (depth > 5 || !isRecord(error)) {
    return false
  }

  if (hasNotFoundMarker(error)) {
    return true
  }

  return (
    isPrestudyRoomCreationUnavailableError(error.cause, depth + 1) ||
    isPrestudyRoomCreationUnavailableError(error.data, depth + 1)
  )
}
